import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import languageLocale from 'utils/LanguageLocale';
import Accordion from 'components/ProductPage/Accordion/Accordion';
import skuUtils from 'utils/Sku';
import RwdProductPageEN from 'components/ProductPage/locales/RwdProductPage_en_US.js';
import RwdProductPageFR from 'components/ProductPage/locales/RwdProductPage_fr_CA.js';

const getText = text => languageLocale.getLocalisedDataFromResource(RwdProductPageEN, RwdProductPageFR)(text);

function HowToUse({ currentSku = {}, content }) {
    const currentSkuType = skuUtils.getProductType(currentSku);

    const isReward = currentSkuType === skuUtils.skuTypes.REWARD;
    const isSubscription = currentSkuType === skuUtils.skuTypes.SUBSCRIPTION;
    const isRougeRewardCard = currentSkuType === skuUtils.skuTypes.ROUGE_REWARD_CARD;

    const title = isSubscription || isRougeRewardCard || isReward ? getText('faq') : getText('howToUse');

    return content ? (
        <Accordion
            title={title}
            id='howtouse'
            dataAt={Sephora.debug.dataAt('how_to_use_btn')}
        >
            <div
                data-at={Sephora.debug.dataAt('how_to_use_section')}
                dangerouslySetInnerHTML={{ __html: content }}
            />
        </Accordion>
    ) : null;
}

HowToUse.shouldUpdatePropsOn = ['currentSku.skuId', 'currentSku.actionFlags'];

export default wrapFunctionalComponent(HowToUse, 'HowToUse');
